<template>
  <div id="app">
  	<header-app></header-app>
    <router-view></router-view>
  </div>
</template>

<script>
import HeaderApp from './components/Header'
import misc from './js/scripts.js'

export default {
  name: 'app',
  components: {
  	HeaderApp
  },
  data(){
    return {
      menuActive: false
    }
  },
  methods: {
    scrollContent(){
      const offset = 60
      document.querySelectorAll('.wrapper-padding-bottom .span-full').forEach( (item) => {
        if( item.getBoundingClientRect().top < offset && item.getBoundingClientRect().bottom > offset ){
          if( item.dataset.header )
            document.querySelector('.header-nav').dataset.color = item.dataset.header || 'white'
        }
      })
    },
    loadGoogleAnalytics(){
       window.location.hostname === 'plastickills.es' && misc.loadScript('https://www.google-analytics.com/analytics.js','googleanalytics').then( () => {
        window.ga = window.ga || function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
        ga('create', 'UA-32961862-5', 'auto');
        ga('send', 'pageview');
        ga('send', {
          hitType: 'pageview',
          page: this.$route.path,
          location: window.location.origin + this.$route.fullPath,
          title: this.$route.name
        });
      })
    }
  },
  created(){
    if( this.$route.params.lang ){
      localStorage.setItem('language',this.$route.params.lang);
      this.$validator.setLocale(this.$route.params.lang);
    } else {
      localStorage.setItem('language','es');
      this.$validator.setLocale('es');
      this.$router.push({
        name: 'Index',
        params: {
          lang: 'es'
        }
      })
    }
  },
  mounted(){
    this.loadGoogleAnalytics()
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// App.vue?5f987e02